import { Action } from "redux";
import { ActionsObservable, StateObservable } from "redux-observable";
import { RootState } from ".";
import { Observable, of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
import { ajax, AjaxResponse } from "rxjs/ajax";
import { SUBMIT_LOGIN_FULFILLED, SUBMIT_LOGIN, LoginAction } from "./login";


export const LOAD_PROFILE = "PROFILE_LOAD_PROFILE";
export const SELECT_PROFILE = "PROFILE_SELECT_PROFILE";
export const COLLAPSE_MENU = "PROFILE_COLLAPSE_MENU";
export const LOAD_PROFILE_FULFILLED = "PROFILE_LOAD_PROFILE_FULFILLED";
export const LOAD_PROFILE_FAILED = "PROFILE_LOAD_PROFILE_FAILED";

export interface Node {
    id: string,
    preview_type: string[],
    [field_name: string]: string | string[] | number
}


export interface ProfileState {
    profiles: Node[],
    loaded: boolean,
    selected?: number,
    collapsed: boolean,
}

const initialState: ProfileState = {
    profiles: [],
    loaded: false,
    collapsed: document.body.clientWidth <= 840 //Don't show sidebar if we're in a smaller viewport
};

export interface LoadProfileFulfilledAction extends Action {
    type: "PROFILE_LOAD_PROFILE_FULFILLED",
    profiles: Node[]
}

export interface ToggleProfileAction extends Action {
    type: "PROFILE_SELECT_PROFILE",
    selected?: number
}

export interface CollapseMenuAction extends Action {
    type: "PROFILE_COLLAPSE_MENU",
}

export type ProfileAction = LoadProfileFulfilledAction | LoginAction | ToggleProfileAction | CollapseMenuAction;

export const loadProfileEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.ofType(SUBMIT_LOGIN_FULFILLED).pipe(
        switchMap(action => {

            return ajax.get("api/v1/query/profile", {
                "SBPPortal-Ticket": state$.value.login.ticket,
                "user": state$.value.login.username,
                "email": state$.value.login.email,
                "source": "portal"
            }).pipe(
                map((response: AjaxResponse) => {
                    return {
                        type: LOAD_PROFILE_FULFILLED,
                        profiles: response.response
                    }

                }),
                catchError((error) => of({ type: LOAD_PROFILE_FAILED })))

        }))

export default function reducer(state = initialState, action: ProfileAction): ProfileState {
    switch (action.type) {

        case SUBMIT_LOGIN:
            return {
                ...initialState
            }

        case LOAD_PROFILE_FULFILLED:

            let collapsed = state.collapsed;

            if (action.profiles.length == 0) {
                collapsed = false;
            }


            return {
                ...state,
                profiles: action.profiles,
                selected: undefined,
                loaded: true,
                collapsed
            }

        case SELECT_PROFILE:

            return {
                ...state,
                selected: action.selected
            }

        case COLLAPSE_MENU:
            return {
                ...state,
                collapsed: !state.collapsed
            }

        default:
            return state;
    }

}